import React from 'react';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';
import { FaCamera } from 'react-icons/fa';


export const CoverimageComponent = ({
  selectedChapters, changeCoverImage
}: any) => {

  return (
    <>
      <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>
        <div className=' py-4'>
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <div>
                        <InputLabelContainer label="Pictures" />
                        <img
                          src={selectedChapters?.CoverImageUrl}
                          className="w-12 h-12"
                        />
                        <div
                          onClick={() => changeCoverImage(
                         
                            'Url',
                            'image',
                            selectedChapters,
                           
                          )}
                        >
                          <FaCamera className=' text-2xl text-skin-ouprimary' />
                        </div>
                      </div>
         
          </div>
        </div>
      </div>
    </>
  )
}

export default CoverimageComponent;
